import React, { useState } from "react";
import heart from "../../../../assets/images/heart.png";
import handbye from "../../../../assets/images/handbye.png";
import clap from "../../../../assets/images/clap.png";
import thumbsup from "../../../../assets/images/thumbsup.png";
import smiley from "../../../../assets/images/smily.png";
import percentage from "../../../../assets/images/percentage.png";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import useSocket from "../../websocket/useSocket";
import axiosInstance from "config/axios";

interface Emoji {
  name: string;
  emoji: any;
  subType?: string;
}
interface ReactionPanelProps {
  onClose?: () => void;
}

interface EmojiProps {
  item: Emoji;
  onClick: (emoji: Emoji) => void;
}

const Emoji = ({ item, onClick }: EmojiProps) => {
  return (
    <div
      className="w-16 h-16 flex items-center justify-center mx-1 hover:scale-110 cursor-pointer transition-all"
      onClick={() => onClick(item)}
    >
      <img src={item.emoji} alt="" className="w-full h-full object-contain" />
    </div>
  );
};

const ReactionPanel = ({ onClose }: ReactionPanelProps) => {
  const [selectedEmoji, setSelectedEmoji] = useState<any | null>(null);
  const { live: { settings }, auth } = useSelector((state: RootState) => state);
  const socket = useSocket();
  const userData = useSelector((state: any) => state.auth.user);

  const emojis: Emoji[] = [
    { name: '100', emoji: percentage, subType: '100' },
    { name: 'heart', emoji: heart, subType: 'HEART' },
    { name: 'high_five', emoji: handbye, subType: 'HIGH_FIVE' },
    { name: 'thumbs_up', emoji: thumbsup, subType: 'THUMBS_UP' },
    { name: 'smiley', emoji: smiley, subType: 'SMILEY' },
    { name: 'clap', emoji: clap, subType: 'CLAP' },
  ];

  const chooseEmoji = (element: Emoji) => {
    const payload = {
      type: "show_emojies",
      user_reaction_data: {
        reaction_type: element.name,
        reacted_by: auth.user?.email,
        reacted_by_type: "trainee",
      },
      room_id: settings.roomId,
      timestamp: 565,
    };

    socket.sendMessage(payload);
    saveActions(element?.subType);
    setSelectedEmoji(element.emoji);
    setTimeout(() => {
      setSelectedEmoji(null);
      onClose?.();
    }, 2000);
  };

  const saveActions = async (subType: string) => {
    const session = await axiosInstance.post("/trainee/live_session_plan_preview_trainee", {
      session_map_id: settings.roomId,
    });

    const responseData = session?.data?.responseData || {};
    const allActivities = [
      ...(responseData.prePlannedActivities || []),
      ...(responseData.quickSetupActivities || []),
    ];

    const launchData = allActivities.find((el: any) => el.status === "LAUNCH");
    if (!launchData?.id) return;

    const obj = {
      engagementType: "L_ACTION",
      userId: userData?.id,
      sessionActivityExecutionLogId: launchData?.id,
      isRead: "NO",
      participantId: userData?.id,
      subType: subType,
    };

    await axiosInstance.post("/session/save_session_actions_log", obj);
  };

  return (
    <div className="bg-[#24272C] p-0 rounded-2xl overflow-hidden w-full">
      <div className="flex flex-row justify-center w-full">
        {emojis.map((el, index) => (
          <Emoji key={index} item={el} onClick={chooseEmoji} />
        ))}
      </div>
      {selectedEmoji && (
        <div className="fixed left-0 bottom-0 z-50">
          <img src={selectedEmoji} alt="" className="w-8 h-8" />
        </div>
      )}
    </div>
  );
};

export default ReactionPanel;